import Base from '../core/Base';
import { getAppConfig } from 'larasnap';
import { loadGoogleMaps } from 'larasnap/support';
import { AddressField } from 'larasnap/enums';

/* global google */

export default class extends Base {
    _parent;
    _name;
    _fields = {};
    _fieldNames;
    _googleFields;
    _autocomplete;

    constructor(parent, name) {
        super();

        this._parent = parent;
        this._name = name;
        this._fieldNames = Object.values(AddressField);
        this._googleFields = getAppConfig('google.maps.address_fields');

        this.setWrapper(
            this._parent.find(`.datamodel-address-group[data-name="${name}"]`),
        );

        this._search = this.find('.address-search');
    }

    setEvents() {
        /* const _this = this;
        this._search.on("keypress change", function() {
            _this.search($(this).val());
        });

        this._search.on("focus", this.geolocate.bind(this)); */
        // This function does not work currently
    }

    addField(field) {
        const name = field.getName().replace(`${this._name}_`, '');
        this._fields[name] = field;

        if (Object.keys(this._fields).length === this._fieldNames.length) {
            this.init();
        }

        // This stops chrome from showing autocomplete options from the user's browser data
        field.getInput().attr('autocomplete', 'new-password');
    }

    init() {
        this.setEvents();
        loadGoogleMaps().then(this.initAutocomplete.bind(this));
    }

    initAutocomplete() {
        this._autocomplete = new google.maps.places.Autocomplete(
            this._search.get(0),
            { types: ['geocode'] },
        );
        this._autocomplete.addListener(
            'place_changed',
            this.setAddress.bind(this),
        );

        // This stops chrome from showing autocomplete options from the user's browser data
        setTimeout(() => {
            this._search.attr('autocomplete', 'new-password');
        }, 150);
    }

    setAddress() {
        const address = this.getAddress();

        Object.entries(address).forEach(([field, value]) =>
            this.setFieldValue(field, value),
        );

        this._fieldNames.forEach(field => {
            if (!address[field]) {
                this.setFieldValue(field, '');
            }
        });
    }

    getAddress() {
        const place = this._autocomplete.getPlace();
        const address = {};

        place.address_components.forEach(component => {
            const field = this._googleFields.mapping[component.types[0]];
            if (field) {
                address[field] = component.short_name;
            }
        });

        Object.entries(this._googleFields.combine).forEach(([name, fields]) => {
            const values = [];
            fields.forEach(field => {
                values.push(address[field]);
                delete address[field];
            });
            address[name] = values.join(' ');
        });

        return address;
    }

    setFieldValue(field, value) {
        this._fields[field].setValue(value);
    }

    geolocate() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                const geolocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                const circle = new google.maps.Circle({
                    center: geolocation,
                    radius: position.coords.accuracy,
                });
                this._autocomplete.setBounds(circle.getBounds());
            });
        }
    }
}
